import React, {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import StyleContext from "../../contexts/StyleContext";
import {useAuth} from "../../contexts/AuthContext";
import {login as apiLogin} from "../../services/api";
import GlobalLoader from "../../components/loader/GlobalLoader";
import "../blog/Blog.scss";

const AdminLogin = () => {
  const {isDark} = useContext(StyleContext);
  const {login} = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await apiLogin(username.trim(), password);
      if (!res?.user || !res?.token) throw new Error(res?.error || "Login failed");
      if (res.user.role !== "admin") throw new Error("This account is not an admin.");
      login(res.user, res.token);
      nav("/admin");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className={`admin ${isDark ? "dark" : ""}`}>
      <h1>Admin Login</h1>
      <p className="admin__lead">Sign in to manage your blog posts.</p>

      <div className="admin__form-card" style={{maxWidth: 520}}>
        <form
          className={`rdf-form ${isDark ? "rdf-dark" : ""}`}
          onSubmit={submit}
          noValidate
        >
          <div className="rdf-group">
            <label className="rdf-label" htmlFor="al-username">Username</label>
            <input
              id="al-username"
              type="text"
              className="rdf-input"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
              autoComplete="username"
              placeholder="admin"
            />
          </div>

          <div className="rdf-group">
            <label className="rdf-label" htmlFor="al-password">Password</label>
            <input
              id="al-password"
              type="password"
              className="rdf-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Your admin password"
            />
          </div>

          {err && <p className="rdf-banner-error" role="alert">{err}</p>}

          <button type="submit" className="rdf-button" disabled={busy}>
            {busy ? (
              <>
                <GlobalLoader inline compact />
                <span>Signing in…</span>
              </>
            ) : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
